import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { FALLBACK_STRINGS } from "@/fallback/config"

interface ConfigStore {
  strings: Record<string, string>
  setStrings: (strings: Record<string, string>) => void
  getString: (code: string) => string
  getStringWithParameters: (
    code: string,
    parameters: Record<string, string>,
  ) => string
}

export const useConfigStore = create<ConfigStore>()(
  devtools(
    (set, get) => ({
      strings: FALLBACK_STRINGS,
      setStrings: (strings: Record<string, string>) => {
        for (const code in FALLBACK_STRINGS) {
          if (strings[code] === undefined) {
            strings[code] = FALLBACK_STRINGS[code]
          }
        }

        set({ strings: strings })
      },
      getString: (code) => {
        const strings = get().strings
        const value = strings[code]
        if (!value) {
          console.warn(`String with code "${code}" not found`)
          return code
        }
        return value
      },
      getStringWithParameters: (
        code: string,
        parameters: Record<string, string> = {},
      ) => {
        const strings = get().strings
        const value = strings[code]
        if (!value) {
          console.warn(
            `String with code "${code}" not found in config or defaults`,
          )
          return code
        }

        let result = value
        for (const [pattern, replacement] of Object.entries(parameters)) {
          result = result.replace(
            new RegExp("{" + pattern + "}", "g"),
            replacement,
          )
        }

        return result
      },
    }),
    { name: "config-store", enabled: process.env.NODE_ENV !== "production" },
  ),
)
